<template>
	<input
		class="input"
		:class="{ 'error-border': props.error }"
		v-bind="$attrs"
		:value="props.modelValue"
		@input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
	/>
</template>

<script setup lang="ts">
const props = defineProps<{
	modelValue: string | number | boolean;
	error?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);
</script>

<style scoped>
.input {
	width: 100%;
	box-sizing: border-box;
	display: inline-flex;
	border-radius: var(--size-xs);
	border: none;
	padding: var(--size-s);
	background-color: var(--secondary-background-color);
	color: var(--text-color);
	font-size: var(--size-m);

	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 17px 14px;
	gap: 10px;

	background: #090e1c;
	border: 1px solid #252f4a;
	border-radius: 16px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 120%;
	color: #ffffff;
}

.input:focus {
	outline: 2px solid #027aff;
}
</style>
